const localizers = {
  'loading.msg': () => `正在載入…`,
  'logon.message.msg': () => `需要驗證。請輸入有效的使用者 ID 和密碼。`,
  'logon.button.msg': () => `登入…`,
  'SASServer.logonError.msg': () => `無法登入伺服器。`,
  'SASServer.genericError.msg': () => `無法連到伺服器。`,
}
export default localizers;
